export function getSocketBaseUrl() {
  const isBrowser = typeof window !== 'undefined';
  const normalizeBase = (value) => {
    if (!value) return value;
    let v = value.replace(/\/$/, '');
    // If API URL includes '/api', strip it for socket connections
    if (v.endsWith('/api')) v = v.slice(0, -4);
    return v;
  };

  const envUrl = normalizeBase(import.meta.env.VITE_API_URL);
  if (envUrl && /^https?:\/\//i.test(envUrl)) return envUrl;

  if (isBrowser && import.meta.env.DEV) {
    // In dev mode, use the current origin (e.g., http://localhost:5173) 
    // and let the Vite proxy handle the forwarding to port 5001.
    // This avoids CORS issues and ensures the connection goes through the same channel as the API.
    return normalizeBase(window.location.origin);
  }

  if (isBrowser && window.API_URL) {
    return normalizeBase(window.API_URL);
  }

  if (isBrowser) {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    const port = window.location.port ? `:${window.location.port}` : '';
    return normalizeBase(`${protocol}//${hostname}${port}`);
  }

  return '';
}
